










































import { Component, Prop, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class ConfirmPasswordModal extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public action!: string;

  @Prop({ required: true })
  public message!: string;

  @Prop({ default: true })
  public autoClose!: boolean;

  // Data

  public confirmPassword = "";
  public isProcessing = false;

  // Computed

  public get formIsInvalid(): boolean {
    return this.hasErrors;
  }

  // Methods

  public async confirm() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      this.isProcessing = true;
      this.$emit("confirmed", this.confirmPassword);
      if (this.autoClose) return this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
